module.exports = __webpack_public_path__ + "img/lqsx_3.b69a69cc.svg";